var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5L4.5 10.5C4.10231 10.4995 3.72105 10.3414 3.43984 10.0602C3.15864 9.77895 3.00045 9.39768 3 9L3 5.25C3.00045 4.85231 3.15864 4.47105 3.43984 4.18984C3.72105 3.90864 4.10231 3.75045 4.5 3.75L19.5 3.75C19.8977 3.75045 20.279 3.90864 20.5602 4.18984C20.8414 4.47105 20.9995 4.85231 21 5.25L21 9C20.9995 9.39769 20.8414 9.77895 20.5602 10.0602C20.279 10.3414 19.8977 10.4995 19.5 10.5ZM21 18.75L21 15C20.9995 14.6023 20.8414 14.221 20.5602 13.9398C20.279 13.6586 19.8977 13.5005 19.5 13.5L4.5 13.5C4.10231 13.5005 3.72105 13.6586 3.43984 13.9398C3.15864 14.221 3.00045 14.6023 3 15L3 18.75C3.00045 19.1477 3.15864 19.529 3.43984 19.8102C3.72105 20.0914 4.10231 20.2495 4.5 20.25L19.5 20.25C19.8977 20.2495 20.279 20.0914 20.5602 19.8102C20.8414 19.529 20.9995 19.1477 21 18.75Z",
    fill: "#2463AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/Columns.8d3bbaea43f7956b17d3405a433e8f9a.svg";
export { ForwardRef as ReactComponent };